import moment from 'moment'

export type DateRangePreset = '7' | '30' | '90' | 'custom'

export function presetToRange(preset: Exclude<DateRangePreset, 'custom'>) {
	const end = moment().endOf('day')
	const days = Number(preset)
	const start = moment()
		.subtract(days - 1, 'days')
		.startOf('day')
	return {
		dateFrom: start.format('YYYY-MM-DD'),
		dateTo: end.format('YYYY-MM-DD'),
	}
}

export function toApiDateRange(dateFrom: string, dateTo: string) {
	return {
		dateFrom: moment(dateFrom).startOf('day').toISOString(),
		dateTo: moment(dateTo).endOf('day').toISOString(),
	}
}

export function formatRangeLabel(dateFrom: string, dateTo: string) {
	return `${moment(dateFrom).format('MMM D, YYYY')} – ${moment(dateTo).format('MMM D, YYYY')}`
}

export function filterByDateRange<T extends { createdOn: string }>(rows: T[], dateFrom: string, dateTo: string) {
	const start = moment(dateFrom).startOf('day')
	const end = moment(dateTo).endOf('day')
	return rows.filter((row) => {
		const d = moment(row.createdOn)
		return d.isValid() && !d.isBefore(start) && !d.isAfter(end)
	})
}

export function buildDailyBuckets<T extends { createdOn: string }>(
	rows: T[],
	dateFrom: string,
	dateTo: string,
	valueFn: (row: T) => number,
	matchFn?: (row: T) => boolean
) {
	const start = moment(dateFrom).startOf('day')
	const end = moment(dateTo).startOf('day')
	const days = Math.max(end.diff(start, 'days') + 1, 1)

	const buckets = Array.from({ length: days }, () => 0)
	const labels = Array.from({ length: days }, (_, i) => {
		const d = start.clone().add(i, 'days')
		return days <= 14 ? d.format('ddd D') : d.format('MMM D')
	})

	for (const row of rows) {
		if (matchFn && !matchFn(row)) continue
		const d = moment(row.createdOn).startOf('day')
		if (!d.isValid() || d.isBefore(start) || d.isAfter(end)) continue
		const idx = d.diff(start, 'days')
		if (idx >= 0 && idx < days) buckets[idx] += valueFn(row)
	}

	return { buckets, labels }
}
